import { CardInfo } from "@models/card-info.model";
import { BaseConverter } from "@converter/BaseConverter";
import { CardInfoDto } from "@dtos/card-info.dto";
import { ChildrenConverter } from "@converter/childrenConverter";

export class CardInfoConverter extends BaseConverter<CardInfo, CardInfoDto>{
    private childrenConverter = new ChildrenConverter();
    modelToDto(model: CardInfo): CardInfoDto {
        return new CardInfoDto(
            model.id,
            model.displaySorting,
            model.visible,
            model.active,
            model.creationDate?.toISOString(),
            model.updateDate?.toISOString(),
            model.parentIdCard,
            model.photo,
            model.title,
            model.type,
            model.children? this.childrenConverter.modelsToDtos(model.children):undefined
        )
    }

    dtoToModel(dto: CardInfoDto): CardInfo {
        return new CardInfo(
            dto.id,
            dto.displaySorting,
            dto.visible,
            dto.active,
            dto.creationDate? new Date(dto.creationDate) : undefined,
            dto.updateDate? new Date(dto.updateDate) : undefined,
            dto.parentIdCard,
            dto.photo,
            dto.title,
            dto.type,
            dto.children? this.childrenConverter.dtosToModels(dto.children):undefined
        )
    }
}